import { createAsyncThunk } from "@reduxjs/toolkit";
import { backend, GetLensRunResponse, LensRunParams } from "Backend";
import { DocumentIntakeBookmark, GetIntakeBookmarksDocument } from "generated/graphql";
import { runGqlQuery } from "gqlClient";
import type { RootState } from "redux/store";

interface FetchLensRunProps extends LensRunParams {
  documentSegmentId: number;
  pageNumber: number;
}

interface FetchLensRunResponse extends GetLensRunResponse {
  documentSegmentId: number;
  pageNumber: number;
}

export const fetchPageLensHits = createAsyncThunk<FetchLensRunResponse, FetchLensRunProps>(
  "intakeViewer/fetchLensRun",
  async ({ lensId, caseId, offset, limit, includeSurroundings, filters, documentSegmentId, pageNumber }) => {
    const result = await backend.getLensRun({
      lensId,
      caseId,
      offset,
      limit,
      includeSurroundings,
      filters: {
        ...filters,
        documentIds: [documentSegmentId],
        pageNumbers: [pageNumber],
      },
    });
    return {
      ...result,
      documentSegmentId,
      pageNumber,
    };
  }
);

export const ensurePageLensHits = createAsyncThunk<FetchLensRunResponse, FetchLensRunProps>(
  "intakeViewer/fetchLensRun",
  (fetchProps, { dispatch }) => dispatch(fetchPageLensHits(fetchProps)).unwrap(),
  {
    condition: (props, { getState }) => {
      // A false return value signals cancellation of the thunk
      const { intakeviewer } = getState() as RootState;
      const documentSegment = intakeviewer.documentSegments[props.documentSegmentId];
      const pageCache = documentSegment ? documentSegment[props.pageNumber] : undefined;
      if (pageCache && pageCache.lensRun) {
        return false;
      }
    },
  }
);

export const fetchBookmarks = createAsyncThunk<DocumentIntakeBookmark[], { caseId: number; intakeId: number }>(
  "intakeViewer/fetchBookmarks",
  async (params) => await runGqlQuery(GetIntakeBookmarksDocument, params).then((r) => r.case.documentBookmarks)
);
